import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import bg from "./bg/signin.svg";
import bgimg from "./bg/backimg.jpg";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import Avatar from "@mui/material/Avatar";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { useState, forwardRef, useEffect } from "react";
import Snackbar from "@mui/material/Snackbar";
import Stack from "@mui/material/Stack";
import MuiAlert from "@mui/material/Alert";
import Slide from "@mui/material/Slide";
import { useNavigate } from "react-router-dom";
import axios from "axios";
// import configration from "../config/config";
import { ToastContainer, toast } from "react-toastify";
import config from "../pages/config";
import { eyeOff } from "react-icons-kit/feather/eyeOff";
import { eye } from "react-icons-kit/feather/eye";
import { Icon } from "react-icons-kit";
import { FaEye } from "react-icons/fa";
import { makeApiRequest } from "../axiosService/apiCall";
import { useFormik } from "formik";
import { encryptData, decryptData } from '../axiosService/Security';
import * as yup from "yup";

const Alert = forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const darkTheme = createTheme({
  palette: {
    mode: "dark",
  },
});

const boxstyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "75%",

  bgcolor: "background.paper",
  boxShadow: 24,
};

const center = {
  position: "relative",
  top: "50%",
  left: "37%",
};

export default function Login() {
  const [open, setOpen] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const vertical = "top";
  const horizontal = "right";
  const navigate = useNavigate();
  const [type, setType] = useState("password");
  const [icon, setIcon] = useState(eyeOff);
  const [loginError, setLoginError] = useState("");

  const handleToggle = () => {
    if (type === "password") {
      setIcon(eye);
      setType("text");
    } else {
      setIcon(eyeOff);
      setType("password");
    }
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  function TransitionLeft(props) {
    return <Slide {...props} direction="left" />;
  }

  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
      otpCode: 0,
    },
    validationSchema: yup.object().shape({
      email: yup
        .string()
        .email("Invalid Email..")
        .required("Enter your Email..."),
      password: yup
        .string()
        .required("Enter your Password...")
        .min(8, "Password must be at least 8 characters long")
        .matches(/[a-z]/, "Password must contain at least one lowercase letter")
        .matches(/[A-Z]/, "Password must contain at least one uppercase letter")
        .matches(/\d/, "Password must contain at least one number")
        .matches(
          /[!@#$%^&*(),.?":{}|<>]/,
          "Password must contain at least one special character"
        ),
    }),
    onSubmit: async (values) => {
      try {
        // const formData = new FormData();
        // formData.append("email", values.email);
        // formData.append("password", values.password);
        // formData.append("otpCode", values.otpCode);

        const encryptedPayload = encryptData({
          email: values.email,
          password: values.password,
          otpCode: values.otpCode,
        });

        let params = {
          url: "adminLogin",
          method: "POST",
          data: { encryptedData: encryptedPayload },
        };

        const response = await makeApiRequest(params);

        if (response.encryptedData) {
          const decryptedResponse = decryptData(response.encryptedData);
          if (decryptedResponse && decryptedResponse.JwtToken) {
            const token = decryptedResponse.JwtToken;
            localStorage.setItem("email", email);
            localStorage.setItem("token", token);
          }
          const gettoken = localStorage.getItem("token");
          if (decryptedResponse.status === true) {
            toast.success(decryptedResponse.message);
            setTimeout(() => {
              gettoken ? navigate("/admin-wallet") : navigate("/");
            }, 3000);
          } else {
            toast.warn(decryptedResponse.message);
          }
        } else {
          toast.warn(response.message);
        }

      } catch (error) {
        // console.log(error);
        if (error.response) {
          const { data } = error.response;
          if (data) {
            toast.error(data);
          } else {
            toast.error("An error occurred while processing your request.");
          }
        } else {
          toast.error("An unexpected error occurred.");
        }
      }
    },
  });

  return (
    <>
      <ToastContainer />
      <Snackbar
        open={open}
        autoHideDuration={3000}
        onClose={handleClose}
        TransitionComponent={TransitionLeft}
        anchorOrigin={{ vertical, horizontal }}
      >
        <Alert onClose={handleClose} severity="error" sx={{ width: "100%" }}>
          Failed! Enter correct userEmail and password.
        </Alert>
      </Snackbar>
      <div
        style={{
          backgroundSize: "cover",
          height: "100vh",
          color: "#f5f5f5",
          backgroundColor: "rgba(9, 116, 155, 1)",
        }}
      >
        <Box sx={boxstyle}>
          <Grid container>
            <Grid item xs={12} sm={12} lg={6}>
              <Box
                style={{
                  backgroundImage: `url(${bg})`,
                  backgroundSize: "cover",
                  marginTop: "40px",
                  marginLeft: "15px",
                  marginRight: "15px",
                  height: "63vh",
                  color: "#f5f5f5",
                }}
              ></Box>
            </Grid>
            <Grid item xs={12} sm={12} lg={6}>
              <Box
                style={{
                  backgroundSize: "cover",
                  height: "70vh",
                  minHeight: "500px",
                  backgroundColor: "rgba(9, 116, 155, 1)",
                }}
              >
                <ThemeProvider theme={darkTheme}>
                  <Container>
                    <Box height={35} />
                    <Box sx={center}>
                      <Avatar sx={{ ml: "35px", mb: "4px", bgcolor: "#ffffff" }}>
                        <LockOutlinedIcon />
                      </Avatar>
                      <Typography component="h1" variant="h4">
                        <a>Sign In</a>
                      </Typography>
                    </Box>
                    <Box
                      component="form"
                      noValidate
                      onSubmit={formik.handleSubmit}
                      sx={{ mt: 2 }}
                    >
                      <Grid container spacing={1}>
                        <Grid item xs={12} sx={{ ml: "3em", mr: "3em" }}>
                          <TextField
                            required
                            fullWidth
                            id="email"
                            label="UserEmail"
                            name="email"
                            type="email"
                            value={formik.values.email}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                          />
                          <span style={{ color: "red" }}>
                            {formik.errors.email && formik.touched.email && (
                              <p>{formik.errors.email}</p>
                            )}
                          </span>
                        </Grid>

                        <Grid
                          item
                          xs={12}
                          sx={{ ml: "3em", mr: "3em" }}
                          className="position-relative"
                        >
                          <div className="mt-3">
                            <TextField
                              required
                              fullWidth
                              type={type}
                              name="password"
                              label="Password"
                              value={formik.values.password}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              id="password"
                            />
                          </div>
                          <div
                            className="new-password-positioning"
                            style={{ width: "fit-content" }}
                          >
                            <Icon
                              class="absolute mr-10"
                              icon={icon}
                              size={25}
                              onClick={handleToggle}
                            />
                          </div>
                          <span style={{ color: "red" }}>
                            {formik.errors.password && formik.touched.password && (
                              <p>{formik.errors.password}</p>
                            )}
                          </span>
                        </Grid>

                        <Grid item xs={12} sx={{ ml: "3em", mr: "3em" }}>
                          <Stack direction="row" spacing={2}>
                            <Typography
                              variant="body1"
                              component="span"
                              onClick={() => {
                                navigate("/forgot-password");
                              }}
                              style={{ marginTop: "10px", cursor: "pointer" }}
                            >
                              Forgot password?
                            </Typography>
                          </Stack>
                        </Grid>
                        <Grid item xs={12} sx={{ ml: "5em", mr: "5em" }}>
                          <Button
                            type="submit"
                            variant="contained"
                            fullWidth="true"
                            size="large"
                            sx={{
                              mt: "10px",
                              mr: "20px",
                              borderRadius: 28,
                              color: "#ffffff",
                              minWidth: "170px",
                              background: "rgba(63, 202, 241, 1)",
                            }}
                          >
                            Sign in
                          </Button>
                        </Grid>
                      </Grid>
                    </Box>
                  </Container>
                </ThemeProvider>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </div>
    </>
  );
}
